<form [formGroup]="propertyDetailsFormGroup">
  <div class="row">
    <div class="col-md-6 form-group">
      <file-input [file]="unitImage" [fileIndex]="1" [fileName]="'name'" [fileLabel]="'fileLabel'"
        (delete)="deleteImage($event)" (save)="handleImage($event)"></file-input>
    </div>

    <div class="col-md-6">
      <div class="form-group">
        <label class="form-label">
          اسم العقار
          <span class="red">*</span>
        </label>
        <input type="text" formControlName="custom_name" class="form-control"
          placeholder="اسم العقار لتمييزه مثال:شقة الياسمين في الرياض" />
      </div>
    </div>

    <div class="col-md-6">
      <div class="form-group">
        <label for="" class="form-label"> نوع العقار <span class="red">*</span></label>
        <ng-select bindLabel="name" class="single-select" #buildingUnit placeholder="يرجى تحديد نوع العقار"
          appendTo="body" formControlName="building_type" [searchable]="true" [clearable]="true">
          @for (type of buildingTypes; track type) {
          <ng-option [value]="type.id">
            {{ type.name }}
          </ng-option>
          }
        </ng-select>
      </div>
    </div>

    <div class="col-md-6">
      <div class="form-group">
        <label for="" class="form-label">
          المساحة
          <span class="red">*</span>
        </label>
        <span class="static-code">م<sup>2</sup></span>
        <input type="number" formControlName="land_area" class="form-control"
          placeholder=" يرجى تحديد مساحة العقار " />
        <img class="form-control-feedback" alt="" src="assets/images/svg/error-icon1.svg" />
      </div>
    </div>

    <div class="col-md-6">
      <div class="form-group">
        <label for="" class="form-label">
          عمر العقار
          <span class="red">*</span>
        </label>
        <input type="number" formControlName="age" class="form-control"
          placeholder=" يرجى تحديد عمر العقار " />
        <img class="form-control-feedback" alt="" src="assets/images/svg/error-icon1.svg" />
      </div>
    </div>
  </div>
</form>
